import { ProxySelectRegistrationTranslator } from 'src/translators'
import { ProxySelectRegistrationFormEntity } from 'src/types'
import { useRegisterSelectsMutation } from 'src/types/generated'

type ProxySelectRegistrationInput = {
  projectId: string
  roomId: string
  formEntity: ProxySelectRegistrationFormEntity
}

export const useProxySelectRegistration = () => {
  const [registerSelectsMutation] = useRegisterSelectsMutation()

  const proxySelectRegistration = async (input: ProxySelectRegistrationInput) => {
    const { projectId, roomId, formEntity } = input
    const selects = ProxySelectRegistrationTranslator.toRequests(formEntity)
    await registerSelectsMutation({
      variables: {
        projectId,
        input: { roomId: Number(roomId), selects },
      },
    })
  }

  return {
    proxySelectRegistration,
  }
}
